import { BaseEventCommand } from './base-event-command.model';

export class UpdateEventCommand extends BaseEventCommand {
    id: string;
}
